import React from 'react';
import '../CSS/Profile/LincolnMehtaProfile.css';

const LincolnMehtaProfile: React.FC = () => {
  const imagePath = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/licoln-mehta-image.png`;
  const linkedInIcon = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Icons/linkedin-blue-icon.svg`;

  return (
    <div className="profile-page">
      <div className="profile-header">
        <div className="profile-picture-container">
          <img 
            src={imagePath}
            alt="Lincoln Mehta"
            className="profile-picture"
          />
        </div>
      </div>
      <div className="profile-content">
        <h1 className="profile-name">Lincoln Mehta</h1>
        <div className="profile-title-container">
          <p className="profile-title">Chief Financial Officer</p>
          <a href="https://www.linkedin.com/in/lincoln-mehta-5a194324" target="_blank" rel="noopener noreferrer">
            <img 
              src={linkedInIcon}
              alt="LinkedIn"
              className="profile-linkedin-icon"
            />
          </a>
        </div>
        <div className="profile-desc">
          <p>
            In her current role as a CFO, Lincoln oversees all corporate finance functions, including financial reporting, tax filings, internal audits, M&As, risk management, financial planning and analysis, and financial strategy development. Her leadership is marked by a self-driven and collaborative approach, coupled with a problem-solving mindset. Lincoln's passion and energy infuses each role with dedication and enthusiasm, always in alignment with the organization's core mission.
          </p>
          <p>
            Lincoln holds an MBA in Finance and is an active CPA licensed in the state of Delaware. She is a proud member of the American Institute of Certified Public Accountants and the Institute of Management Accountants.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LincolnMehtaProfile;
